import { render, staticRenderFns } from "./ListWithPageA.vue?vue&type=template&id=5b85357f&scoped=true&"
import script from "./ListWithPageA.vue?vue&type=script&lang=js&"
export * from "./ListWithPageA.vue?vue&type=script&lang=js&"
import style0 from "./ListWithPageA.vue?vue&type=style&index=0&id=5b85357f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b85357f",
  null
  
)

export default component.exports